import { IconButton, makeStyles } from "@material-ui/core";
import { useState } from "react";
import ReactDOM from "react-dom";
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

import { useControl } from 'react-map-gl';
import mapboxgl from 'mapbox-gl';

export const ResizeControl = ({ onClick }: { onClick: (maximized: boolean) => void }) => {
  useControl(() => {
    return new ResizeControlClass(onClick);
  }, { position: 'top-left' });

  return null;
}

class ResizeControlClass implements mapboxgl.IControl {
  _container: HTMLElement;
  constructor(
    private onClick: (maximized: boolean) => void,
  ) {
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
  }
  onAdd(): HTMLElement {
    ReactDOM.render(
      <ResizeControlUI onClick={this.onClick} />,
      this._container
    );
    return this._container;
  }
  onRemove() {
    ReactDOM.unmountComponentAtNode(this._container);
    this._container.remove();
  }
}

const useControlsStyles = makeStyles(() => ({
  button: {
    padding: 8,
    margin: 2,
    width: "26px !important",
    height: "26px !important"
  },
  icon: {
    width: "16px",
    height: "16px",
    color: "#000000"
  }
}));

interface ResizeControlUIProps {
  onClick: (maximized: boolean) => void;
}

const ResizeControlUI: React.FC<ResizeControlUIProps> = ({ onClick = () => {/** Nothing to do here */ } }) => {
  const [maximized, setMaximized] = useState(false);
  const classes = useControlsStyles();

  const handleClick = () => {
    setMaximized((prev) => {
      onClick(!prev);
      return !prev;
    });
  };

  return (
    <IconButton
      title="Resize"
      onClick={handleClick}
      className={classes.button}
    >
      {maximized ?
        (<FullscreenExitIcon className={classes.icon} />) :
        (<FullscreenIcon className={classes.icon} />)}
    </IconButton>
  );
};